<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="800"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Custom headers</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column min-h-300px scroll-y mx-5 py-7">
        <!--begin::Actions-->
        <div class="w-100 text-right">
          <div class="">
            <button
              @click.prevent="showActionDialog('create')"
              class="btn btn--export-filter p-3"
            >
              <span class="svg-icon">
                <v-icon size="18">mdi-plus-box-outline</v-icon>
              </span>
              <span>Add Header</span>
            </button>
          </div>
        </div>
        <template class="w-100">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ID</th>
                  <th class="text-left">KEY</th>
                  <th class="text-left">VALUE</th>
                  <th class="text-left">ACTION</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.key">
                  <td>{{ item.id }}</td>
                  <td>{{ item.key }}</td>
                  <td>{{ item.value_data }}</td>
                  <td>
                    <v-menu
                      left
                      transition="scale-transition"
                      offset-y
                      bottom
                      rounded
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <a
                          v-bind="attrs"
                          v-on="on"
                          class="btn btn-light-light btn-hover-info show poppins min-w-100px"
                        >
                          Actions
                          <span class="svg-icon svg-icon-5 m-0">
                            <v-icon small>mdi-chevron-down</v-icon>
                          </span>
                        </a>
                      </template>
                      <v-card class="poppins py-1" elevation="0">
                        <v-btn
                          @click.prevent="showActionDialog('edit', item)"
                          class="d-block w-100"
                          text
                          >Edit</v-btn
                        >
                        <v-btn
                          @click.prevent="deleteHeader(item)"
                          class="d-block w-100 text-danger"
                          text
                          >Delete</v-btn
                        >

                        <!-- {{ item.extra_data.actions }} -->
                      </v-card>
                    </v-menu>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
        <!-- action dialog -->
        <HeadersActionDialog
          ref="headerActionDialog"
          :refresher="loadCustomHeaderData"
          :pageLoader="pageLoader"
          :action_type="action_type"
          :item="item"
        />
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
      <div class="pb-7 d-flex flex-grow-1 align-end justify-center">
        <button class="btn btn-info px-5 py-3 ls1" @click="toggleModal">
          Close
        </button>
      </div>
      <!--end::Actions-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ApiService from "@/core/services/api.service.js";
import DatatableDetail from "@/own/components/datatable/DatatableDetail";
import HeadersActionDialog from "@/own/components/datahub/webhooks/HeadersActionDialog.vue";
import Swal from "sweetalert2";
// import ManageHeadersTable from "@/own/components/datahub/Webhooks/ManageHeadersTable.vue";

export default {
  name: "ManageHeaders",
  components: { HeadersActionDialog },
  data: () => ({
    dialog: false,
    items: [],
    action_type: "create",
    item: null,
  }),
  methods: {
    toggleModal() {
      if (!this.dialog) {
        this.loadCustomHeaderData();
      }
      this.dialog = !this.dialog;
    },
    async loadCustomHeaderData() {
      this.$store.commit(SET_PAGE_LOADING, true);

      const payload = {
        webhook_id: this.itemForAction.id,
      };
      const datatable = await ApiService.post(
        `/datahub/webhooks/webhook_headers/datatable`,
        payload
      );

      this.items = datatable.data.body;

      this.$store.commit(SET_PAGE_LOADING, false);
      // ApiService.post(`/datahub/webhooks_headers`, payload)
      //   .then(({ data }) => {
      //     this.headers = data.data.columns;
      //   })
      //   .then(() => {
      //     ApiService.post(`/datahub/webhooks_headers/datatable`, payload).then(
      //       ({ data }) => {
      //         this.items = data.data.data;
      //       }
      //     );
      //   })
      //   .finally(() => {
      //     this.$store.commit(SET_PAGE_LOADING, false);
      //   });
    },
    showActionDialog(type = "create", item) {
      this.action_type = type;
      if (type === "edit") {
        this.item = item;
      }
      setTimeout(() => {
        this.$refs.headerActionDialog.toggleModal();
      }, 100);
    },
    deleteHeader(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.pageLoader(true);
          //TODO: change data sending to id
          const payload = {
            webhook_id: this.itemForAction.id,
            id: item.id,
          };
          ApiService.post(`/datahub/webhooks/webhook_headers/destroy`, payload)
            .then(() => {
              Swal.fire("Deleted!", "Record has been deleted.", "success");
              this.loadCustomHeaderData();
            })
            .catch(() => {
              this.pageLoader(false);
            });
        }
      });
    },
    pageLoader(val = true) {
      this.$store.commit(SET_PAGE_LOADING, val);
    },
  },
  computed: {
    itemForAction() {
      return this.$store.getters.getItemForAction;
    },
  },
};
</script>
